import React from 'react';
import * as Household from './household.js';

import * as View from './view.js';
import * as $ from 'jquery';

var listData;
var customers = {
    resetFormNew: function() {
        $("#add_customers_name").val("")
        $("#add_customer_name").parent().removeClass("is-dirty")

        $("#add_customer_company").val("")
        $("#add_customer_company").parent().removeClass("is-dirty")

        $("#add_customer_email").val("")
        $("#add_customer_email").parent().removeClass("is-dirty")

        $("#add_customer_telephone").val("")
        $("#add_customer_telephone").parent().removeClass("is-dirty")

        $("#add_customer_adressLine1").val("")
        $("#add_customer_adressLine1").parent().removeClass("is-dirty")

        $("#add_customer_adressLine2").val("")
        $("#add_customer_adressLine2").parent().removeClass("is-dirty")

        $("#add_customer_adressLine3").val("")
        $("#add_customer_adressLine3").parent().removeClass("is-dirty")

        $("#add_customer_description").val("")
        $("#add_customer_description").parent().removeClass("is-dirty")

        $("#add_customer_price").val("")
        $("#add_customer_price").parent().removeClass("is-dirty")
    },
    submitFormNew: function() {
        var auth = JSON.parse(localStorage.getItem("auth"))

        var form = {
            username: auth.username,
            password: auth.password,
            person: {
                name: $("#add_customer_name").val(),
                email: $("#add_customer_email").val(),
                conpany: $("#add_customer_company").val(),
                addressLine1: $("#add_customer_adressLine1").val(),
                addressLine2: $("#add_customer_adressLine2").val(),
                addressLine3: $("#add_customer_adressLine3").val(),
                telephone: $("#add_customer_telephone").val()    
            }
        }

        var superform = {
            data: JSON.stringify(form)
        }

        $.ajax("https://api.antipy.com:1550/invoice/customers/add", {
            method: "post",
            data: superform,
            dataType: "json",
            success: function (dataIn) {
                var data = dataIn
        
                if (data.success) {
                    Household.showSnack("Added Customer")
                    View.State("customerList")
                } else {
                    Household.showSnack(data.message)
                }    
            },
            error: function (dataIn) {
                var data = dataIn.responseJSON
            
                if (data.success) {
                    Household.showSnack("Added Customer")
                } else {
                    Household.showSnack(data.message)
                }    
            },
        })
    }    
}

export class List extends React.Component {
    render() {
        return (
            <div>
                <h1>Customers</h1>
                <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
                    <thead>
                        <tr>
                            <th class="mdl-data-table__cell--non-numeric">Name</th>
                            <th class="mdl-data-table__cell--non-numeric">Email</th>
                            <th class="mdl-data-table__cell--non-numeric"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ListFiller />
                        <tr>
                            <td class="mdl-data-table__cell--non-numeric"></td>
                            <td class="mdl-data-table__cell--non-numeric"></td>
                            <td><button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" onClick={() => View.State("customerAdd")}><i class="material-icons">add</i></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export class Add extends React.Component {
    render() {
        return (
            <div>
                <h1>Customers</h1>
                <div class="demo-card-wide mdl-shadow--2dp" style={{width: "400px"}}>
                    <div class="mdl-card__supporting-text">
                        <h4>Add Customer</h4>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_name"/>
                            <label class="mdl-textfield__label" for="add_customer_name">Name...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_company"/>
                            <label class="mdl-textfield__label" for="add_customer_company">Company...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_email"/>
                            <label class="mdl-textfield__label" for="add_customer_email">Email...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="telephone" id="add_customer_telephone"/>
                            <label class="mdl-textfield__label" for="add_customer_telephone">Telephone...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_adressLine1"/>
                            <label class="mdl-textfield__label" for="add_customer_adressLine1">Adress Line 1...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_adressLine2"/>
                            <label class="mdl-textfield__label" for="add_customer_adressLine2">Adress Line 2...</label>
                        </div><br/>
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                            <input class="mdl-textfield__input" type="text" id="add_customer_adressLine3"/>
                            <label class="mdl-textfield__label" for="add_customer_adressLine3">Adress Line 3...</label>
                        </div><br/><br/><br/>
                        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect" onClick={() => customers.resetFormNew()}>Reset</button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect" onClick={() => customers.submitFormNew()}>Add</button>
                    </div>
                </div>
            </div>
        );
    }
}

export class Edit extends React.Component {
    render() {
        return (
            <div>
                <h1>Customers</h1>
                
            </div>
        );
    }
}

class ListItem extends React.Component {
    render() {
        return (
            <tr>
                <td class="mdl-data-table__cell--non-numeric">{this.props.name}</td>
                <td class="mdl-data-table__cell--non-numeric">{this.props.email}</td>
                <td><button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" onClick={() => console.log(this.props.id)}><i class="material-icons">edit</i></button></td>
            </tr>
        );
    }
}

function ListFiller() {
    var content = [];
    for (var i = 0; i < listData.length; i++) {   
        content.push(<ListItem name={listData[i].name} email={listData[i].email} id={listData[i].id}/>); 
        if (i+1 === listData.length) {
            return content
        }
    }
}

export function GetArray() {
    var form;

    if (localStorage.getItem("auth")) {
        var loginData = JSON.parse(localStorage.getItem("auth"))
        if (loginData.username && loginData.password) {
            form = loginData
        } else {
            View.State("login")
            return
        }
    } else {
        View.State("login")
        return
    }

    $.ajax("https://api.antipy.com:1550/invoice/customers/list", {
        method: "post",
        data: form,
        dataType: "json",
        success: function (dataIn) {
            var data = dataIn
    
            if (data.success) {
                console.log(data.data)
                listData = data.data
                View.State("customerListReal")
            }
        },
        error: function (dataIn) {
            var data = dataIn.responseJSON
        
            if (!data.success) {
                Household.showSnack(data.message)
            }    
        }
    })
}


// WEBPACK FOOTER //
// ./src/customer.js